// Entwurf aus einem Workflow-Lauf im Komposer öffnen. Der Entwurf wird im Lager (je Lead und Kanal, Schlüssel
// „<lead>|email“ bzw. „<lead>|sms“) abgelegt; der E-Mail-Komposer liest ihn beim Öffnen, macht daraus einen eigenen
// Server-Entwurf und nimmt ihn aus dem Lager (E2E-05). Die Lead-Seite öffnet das E-Mail- bzw. SMS-Fenster damit. Gesendet wird erst auf „Senden“ im Komposer,
// mit allen Prüfungen dort (Kalt-Mail-Schutz, Abmeldungen, Bestätigungen).
import type { NavigateFunction } from "react-router-dom";
import type { Entwurf } from "../api/workflows";
import { entwurfSetzen } from "../daten/entwuerfe";
import { smsVerfassen } from "../daten/schreiben";

export function entwurfOeffnen(navigate: NavigateFunction, leadId: string, entwurf: Entwurf): void {
  const pfad = `/lead/${encodeURIComponent(leadId)}`;
  if (entwurf.art === "email") {
    entwurfSetzen(`${leadId}|email`, { an: entwurf.an, cc: [], bcc: [], betreff: entwurf.betreff, html: entwurf.html, signatur: true });
    navigate(pfad, { state: { schreiben: "email", an: entwurf.an[0] ?? null, kontakt: entwurf.contact_id } });
    return;
  }
  entwurfSetzen(`${leadId}|sms`, { nummer: `${entwurf.contact_id}|${entwurf.telefon}`, text: entwurf.text });
  navigate(pfad);
  // Die Lead-Seite nimmt das Ereignis erst nach dem Aufbau ab: kurz wiederholen, bis jemand es übernimmt.
  let versuche = 0;
  const takt = window.setInterval(() => {
    versuche += 1;
    if (smsVerfassen({ leadId, contactId: entwurf.contact_id }) || versuche >= 25) window.clearInterval(takt);
  }, 160);
}
